export function fillArray<T>(array: T[], targetSize: number, element: T): T[] {
  if (array.length >= targetSize) {
    return array;
  }

  const filler: T[] = new Array(targetSize - array.length).fill(element)
  return [
    ...array,
    ...filler
  ]
}
